import { render, staticRenderFns } from "./ForgotPasswordFormMobile.vue?vue&type=template&id=4f246e64&scoped=true&"
import script from "./ForgotPasswordFormMobile.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordFormMobile.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordFormMobile.vue?vue&type=style&index=0&id=4f246e64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f246e64",
  null
  
)

export default component.exports